var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v("This Page might still be under construction, please check back later")])])
}]

export { render, staticRenderFns }